var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$route.path !== '/home' && _vm.$route.path !== '/media-entry' && !_vm.$route.path.startsWith('/user-center'))?_c('CartBar'):_vm._e(),_c('CollectFolderDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }